import { Helmet } from 'react-helmet-async';
import { useLanguage } from '@/contexts/LanguageContext';
import { useLocation } from 'react-router-dom';
import { SITE_CONFIG } from '@/lib/config';

/**
 * Composant Hreflang pour indiquer à Google les versions linguistiques de chaque page
 * Critique pour SEO multilingue - évite duplicate content et améliore ciblage géographique
 */
export const HreflangTags = () => {
  const { language } = useLanguage();
  const location = useLocation();
  const baseUrl = SITE_CONFIG.domain;
  
  // Supprimer le préfixe de langue actuel du path pour reconstruire les URLs
  // Supprimer aussi les anciennes références à /shop
  const cleanPath = location.pathname.replace(/^\/(fr|en|es|de|it)/, '').replace(/\/shop$/, '') || '/';
  
  // Toutes les langues supportées
  const languages = ['fr', 'en', 'es', 'de', 'it'];
  
  return (
    <Helmet>
      {/* Générer une balise hreflang pour chaque langue */}
      {languages.map(lang => (
        <link
          key={lang}
          rel="alternate"
          hrefLang={lang}
          href={`${baseUrl}/${lang}${cleanPath}`}
        />
      ))}
      
      {/* x-default pointe vers la version française (langue par défaut) */}
      <link
        rel="alternate"
        hrefLang="x-default"
        href={`${baseUrl}/fr${cleanPath}`}
      />
      
      {/* Canonical sur la version de la langue courante */}
      <link 
        rel="canonical" 
        href={`${baseUrl}/${language}${cleanPath}`} 
      />
    </Helmet>
  );
};
